// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-0979e9db]{display:flex}.thumbnail img[data-v-0979e9db]{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.thumbnail[data-v-0979e9db]{-o-object-position:50% 50%;object-position:50% 50%;width:160px;height:200px}", ""]);
// Exports
module.exports = exports;
